module.exports = __webpack_public_path__ + "img/royal-angel.f0b93c98.svg";